export default __webpack_public_path__ + "static/media/card_sheet_template.f28d330f.png";